import './home.css';

import { useContext } from 'react';
import { UserContext } from '../context/UserContext';

export default function AboutAPN() {
  const { user } = useContext(UserContext);
  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h1 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Über das AP‑Network</h1>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>
          Gemeinsam. Sichtbar. Stark. – Das AP‑Network ist ein kuratiertes Netzwerk aus ambitionierten,
          authentischen und engagierten Creator‑Persönlichkeiten. Qualität, Teamgeist und echte Wertschätzung
          sind unser Fundament.
        </p>
      </section>

      {/* Content */}
      <section style={{ width: '100%', maxWidth: 1100, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Mission & Leitgedanke */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Mission & Leitgedanke</h2>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <span aria-hidden="true" style={{fontSize:22}}>🎯</span>
            <span>
              Das AP‑Network ist keine gewöhnliche Community – und keine gewöhnliche Agentur. Es ist ein <b>kuratiertes Netzwerk </b>
              aus ambitionierten, authentischen und engagierten Creator‑Persönlichkeiten. Wir schaffen Strukturen, die Qualität
              fördern und Menschen verbinden, die mit <b>Leidenschaft, Zuverlässigkeit und Kreativität</b> arbeiten.
            </span>
          </p>
        </div>

        {/* Unser Ziel */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Unser Ziel</h2>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <span aria-hidden="true" style={{fontSize:22}}>🏗️</span>
            <span>
              <b>Qualität statt Quantität.</b> Bei uns zählt nicht, wer am lautesten schreit, sondern wer mit echter
              Leidenschaft, Verlässlichkeit und Kreativität arbeitet. Wir setzen auf <b>nachhaltiges Wachstum</b> statt kurzfristiger Hypes.
            </span>
          </p>
        </div>

        {/* Was ist das AP‑Network? */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Was ist das AP‑Network?</h2>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <span aria-hidden="true" style={{fontSize:22}}>🌐</span>
            <span>
              Das AP‑N ist die <b>Weiterentwicklung erfolgreicher Streaming‑Communitys</b>, kombiniert mit den Stärken eines modernen Managements.
              Ziel ist eine Plattform, in der sich Creator:innen <b>gegenseitig unterstützen</b>, vernetzen und <b>gemeinsam wachsen</b> – ohne Druck
              und auf Basis echter Wertschätzung.
            </span>
          </p>
        </div>

        {/* Zentrale Bestandteile */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Zentrale Bestandteile des AP‑N</h2>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', display:'grid', gridTemplateColumns:'1fr', gap:10 }}>
            <li style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>🛠️</span>
              <span className="highlight-desc"><b>Technischer Support</b> – Hilfe bei Setup, Tools, Integrationen und Optimierung.</span>
            </li>
            <li style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>📅</span>
              <span className="highlight-desc"><b>Community‑Events</b> – Aktionen, Challenges und Formate für Sichtbarkeit und Austausch.</span>
            </li>
            <li style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>💻</span>
              <span className="highlight-desc"><b>Umfassende Webanwendung</b> – Automatisierte Systeme, smarte Workflows und hilfreiche Features.</span>
            </li>
            <li style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>👀</span>
              <span className="highlight-desc"><b>Lurker‑Tools</b> – Faire und transparente Mechaniken für Engagement‑Tracking.</span>
            </li>
            <li style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>🤝</span>
              <span className="highlight-desc"><b>Individuelle Creator‑Betreuung</b> – Persönliche Unterstützung durch das AP‑N.</span>
            </li>
          </ul>
        </div>

        {/* Leitmotiv Zitat */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <blockquote style={{ margin:0, padding:'16px 18px', borderLeft:'4px solid #32CD89', background:'rgba(255,255,255,0.03)', borderRadius:8 }}>
            <p style={{ margin:0, fontStyle:'italic', color:'#D4D8DF' }}>
              „Gemeinsam wachsen, ohne Druck – mit echter Wertschätzung und Leidenschaft.“
            </p>
          </blockquote>
        </div>

        {/* Mehr als nur eine Community */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Mehr als nur eine Community</h2>
          <p className="highlight-desc">
            Das AP‑Network verbindet die Vorteile einer <b>modernen Agentur</b> mit der Energie einer <b>kreativen Community</b>.
            Wir bieten Raum für Innovation, Austausch und individuelle Entwicklung.
          </p>
        </div>

        {/* Unsere Philosophie */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Unsere Philosophie</h2>
          <p className="highlight-desc">
            AP‑N steht für <b>Qualität</b>, <b>Innovation</b> und <b>echte Community</b>. Unsere Leistungen sind darauf ausgerichtet,
            Creator auf ihrem Weg zu unterstützen und gemeinsam neue Maßstäbe zu setzen. Egal ob technischer Support, Events
            oder Tools – bei uns findest du alles, was du für deinen Erfolg brauchst.
          </p>
        </div>

        {/* Multiplattform & Formate */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Multiplattform‑Support & alle Formate</h2>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:12 }}>
            <span aria-hidden="true" style={{fontSize:22}}>🔗</span>
            <span>
              Wir beschränken uns <b>nicht</b> auf eine Plattform: Ob Streaming‑Plattformen, Video‑Portale oder Social‑Media –
              wir denken übergreifend und unterstützen echte <b>Multiplattform‑Strategien</b>.
            </span>
          </p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:12 }}>
            {['Streaming','Video','Shorts','Stories','Clips','Podcasts'].map((t,i)=> (
              <span key={i} style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>{t}</span>
            ))}
            <span style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(50,205,137,0.35)', background:'rgba(50,205,137,0.08)', color:'#d8f5e8' }}>Reale Events</span>
          </div>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <span aria-hidden="true" style={{fontSize:22}}>🧩</span>
            <span>
              Unabhängig von der <b>Content‑Art</b>: Livestreams, Videos, Shorts, Stories – sogar <b>reale Events</b> begleiten wir organisatorisch und kommunikativ.
              Wir passen Tools, Prozesse und Empfehlungen an deine Kanäle und Ziele an.
            </span>
          </p>
        </div>

        {/* Inhalte & Bereiche */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Inhalte & Bereiche</h2>
          <p className="highlight-desc" style={{ marginBottom: 10 }}>
            Wir unterstützen Inhalte breit gefächert – von <b>Gaming</b> über <b>IRL</b>, <b>Kochen</b> und <b>Shows</b> bis hin zu <b>NSFW (18+)</b>,
            jeweils im Rahmen geltender Gesetze und Plattform‑Richtlinien.
          </p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            <span style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>🎮 Gaming</span>
            <span style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>🚶 IRL</span>
            <span style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>🍳 Kochen</span>
            <span style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>🎭 Shows</span>
            <span title="Ab 18" style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>🔞 NSFW (18+)</span>
          </div>
          <div style={{ marginTop:10, fontSize:12, color:'#9ca3af' }}>
            Hinweis: Für sensible Inhalte gelten strikte <b>Compliance‑Vorgaben</b> (Gesetze, Plattform‑Regeln, Zahlungsanbieter‑Policies). Wir beraten hierzu transparent.
          </div>
        </div>

        {/* Angebote im Überblick (Verlinkungen) */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Unser Angebot – kurz zusammengefasst</h2>
          <p className="highlight-desc" style={{ marginBottom: 10 }}>
            Von Mentoring & Feedback über Events bis hin zu Tools und Sichtbarkeit: Bei uns findest du,
            was dich als Creator wirklich weiterbringt.
          </p>
          <div style={{ display:'flex', gap: 8, flexWrap:'wrap' }}>
            <a className="hero-btn-secondary" href="/angebote" style={{ padding: '10px 14px', textDecoration:'none' }}>Angebote & Leistungen</a>
            <a className="hero-btn-primary" href="/leistungen-im-detail" style={{ padding: '10px 14px', textDecoration:'none' }}>Leistungen im Detail</a>
          </div>
        </div>

        {/* Community & Events Links */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Community & Events</h2>
          <p className="highlight-desc" style={{ marginBottom: 10 }}>
            Austausch in Chats, gemeinsame Aktionen, Community‑Events und mehr – wir schaffen Räume,
            in denen Zusammenarbeit Spaß macht und Ergebnisse liefert.
          </p>
          <div style={{ display:'flex', gap: 8, flexWrap:'wrap' }}>
            <a className="hero-btn-secondary" href="/mitglieder" style={{ padding: '10px 14px', textDecoration:'none' }}>Unsere Mitglieder</a>
            <a className="hero-btn-secondary" href="/events" style={{ padding: '10px 14px', textDecoration:'none' }}>Events</a>
          </div>
        </div>

        {/* Kontakt CTA */}
        <div className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Noch Fragen?</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Du willst mehr erfahren oder direkt mit uns sprechen? Wir helfen dir gern weiter.
          </p>
          <div style={{ display:'flex', gap: 8, flexWrap:'wrap' }}>
            <a className="hero-btn-primary" href="/kontakt" style={{ padding: '12px 18px', textDecoration:'none' }}>Kontakt aufnehmen</a>
            <a className="hero-btn-secondary" href="/register" style={{ padding: '12px 18px', textDecoration:'none' }}>Jetzt beitreten</a>
          </div>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}